<template>
    <v-container fluid>   
      <LeftMenu  />     
        <v-layout row wrap>  
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="workOrderListComputed"
              :items-per-page="1000"
              item-key="id"
              sort-by="id"
              :sort-desc=true
              class="elevation-1"
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Work Orders</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <template >
                    <v-layout row wrap>  
                      <v-flex xs2 class="pr-3">
                        <DatePicker picker-label="" :date-value="workOrdersStartDate" @dateSelected="workOrdersStartDate=$event" />
                      </v-flex>
                      <v-flex xs2 class="pr-3"> 
                        <DatePicker picker-label="" :date-value="workOrdersEndDate" @dateSelected="workOrdersEndDate=$event" />                  
                      </v-flex> 
                      <v-flex xs3><v-text-field v-model="search" label="Search " class="mx-4"></v-text-field></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2"  @click="searchWorkOrders()">Search</v-btn></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="clearSearch()" >Clear</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="createNewWorkOrder()" >New Work Order</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                    </v-layout>
                  </template>
                </v-toolbar>
              </template> 
              <template v-slot:body.append>                    
              </template>  
              <template v-slot:footer>       
                <Pagination  :record-count="recordCount" :default-page-size="defaultPageSize"
                       @pageNumberChanged="pageNumberChanged($event)" @pageSizeChanged="pageSizeChanged($event)" />             
              </template> 
              <template v-slot:item.goToDetails="{ item }">              
                <v-icon                  
                  @click="goToDetails(item)">
                  mdi-send
                </v-icon>                
              </template>     
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
              </template>       
              <template v-slot:item.action="{ item }">          
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>                                
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import getCurrentDate from '../../helpers/getCurrentDate';
import getThisYearStart from '../../helpers/getThisYearStart';
import LeftMenu from '../../components/LeftMenu';
import DatePicker from '../../components/DatePicker';
import Pagination from '../../components/Pagination';
import formatPrice from '../../helpers/formatter';
const API_URL = 'manufacture/workOrders';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Pagination
    },
    props: {
      currentCustomer : {}
    },
    data () {
    return {
      search: '',
      workOrdersStartDate: '',
      workOrdersEndDate: '',
      workOrders: [
        {     
          customerName: '',
          workOrderDate: '',
          status: '',  
        },               
      ],
      defaultPageSize : 25,
      recordCount : 0,
    }
  },
  computed: {
    headers () {
      return [
        { text: '',align: 'left',sortable: false,value: 'goToDetails'},
        { text: 'Work Order No',  value: 'id'  },  
        { text: 'Assignee',  value: 'assignee.name'  },
        {
          text: 'Sale',align: 'left',sortable: true,
          value: 'sale.id',
        },
        { text: 'Start Date',  value: 'startDate'  },   
        { text: 'Planned End Date',  value: 'plannedEndDate'  },      
        { text: 'End Date', value: 'endDate' }, 
        { text: 'Status',  value: 'status'  },               
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    workOrderListComputed(){
      return this.workOrders.map((item) => {   
        item.totalPriceFormatted = formatPrice(item.totalPrice);
        return item;    
      })
    },
    formTitle () {
      return  'New Work Order';
    },
  },
  created() {    
    this.fillIntervalDates();
    //this.getWorkOrdersByInterval(1,this.defaultPageSize);    
  },
  watch: {
    workOrdersStartDate (val){
      this.workOrdersStartDate = val;
      if(val && this.workOrdersEndDate){        
        this.getWorkOrdersByInterval(1,this.defaultPageSize);   
      }
    },
    workOrdersEndDate(val){
      this.workOrdersEndDate = val;
      if(val && this.workOrdersStartDate){      
        this.getWorkOrdersByInterval(1,this.defaultPageSize);   
      }
    },
  },
  methods: {
    goToDetails(item){
      this.$router.push('/workOrders/'+item.id);
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.workOrdersStartDate = getThisYearStart();
    },
    async setEndDate(){
      this.workOrdersEndDate = getCurrentDate();
    },
    createNewWorkOrder(){
      this.$router.push('/workOrders/new');
    },
    clearSearch(){
      this.search = '';
      this.getWorkOrdersByInterval(1, this.defaultPageSize);
    },
    getStatusColor (status) {
      if(status == '') return ''
      else if (status =='OPEN') return 'blue'
      else if (status =='SOLD') return 'green'
      else if (status =='EXPIRED') return 'orange'
      else return ''
    },
    deleteItem (item) {
      const index = this.workOrders.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.workOrders.splice(index, 1);
        this.deleteWorkOrder(item);
      } 
    },
    generatePdf(item) {          
      this.$axios({
        url: this.$apiurl + API_URL+'/'+item.id+'/generatePdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'WorkOrder_'+item.workOrderNo+'.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
    deleteWorkOrder(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    pageSizeChanged(pageSize){
      this.defaultPageSize = pageSize;
      this.getWorkOrdersByInterval(1, pageSize);
    },
    pageNumberChanged(pageNumber){
      this.getWorkOrdersByInterval(pageNumber, this.defaultPageSize);
    },
    searchWorkOrders(){
      if(!this.search || this.search.length < 3){
        alert('Type at least 3 characters to search!');
        return;
      }
      var url = this.$apiurl + API_URL +"/search/"+this.search;
      this.$axios.get(url)
        .then(response => {
            this.workOrders = response.data;
            this.recordCount = response.data.length;
        }) 
        .catch(error => {
            console.log(error);
        });
    },
    getWorkOrders(pageNumber, pageSize){  
      var url = this.$apiurl + API_URL; 
      url += "/paginated/" + pageSize + "/" + pageNumber;
      this.$axios.get(url)
        .then(response => {
            this.workOrders = response.data.workOrderList;
            this.recordCount = response.data.allWorkOrderCount;
        }) 
        .catch(error => {
            console.log(error);
        });                
    },
    getWorkOrdersByInterval( pageNumber, pageSize ){
      var url = this.$apiurl + API_URL; 
      
      url += "/paginated/" + pageSize + "/" + pageNumber;
      this.$axios.get(url, { 
          params: {
            startDate: this.workOrdersStartDate,
            endDate: this.workOrdersEndDate
          }                                               
        })
        .then(response => {
            this.workOrders = response.data.workOrderList;
            this.recordCount = response.data.allWorkOrderCount;
        }) 
        .catch(error => {
            console.log(error);
        });  
    },
  },
}
</script>
